import { Directive } from '@angular/core';
import {MatAutocompleteTrigger} from '@angular/material/autocomplete';

@Directive({
  selector: 'tvk-autocomplete[matAutocomplete]'
})
export class TvkAutocompleteTrigger extends MatAutocompleteTrigger { };